import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import 'lazysizes'
import 'lazysizes/plugins/attrchange/ls.attrchange'
import 'lazysizes/plugins/bgset/ls.bgset'

import {fetchInitial} from './MainSlice'
import {RootState} from 'store'
import styled from 'styled-components'
import TopSection from '../../components/TopSection'
import SecondSection from '../../components/SecondSection'
import Independent from '../../components/Independent'
import BottomSection from '../../components/BottomSection'
import Loading from '../../components/Loading'
import GlobalPhenomenon from '../../components/GlobalPhenomenon'

const Container = styled.div`
  background-color: #fff;
`

const ErrorMessage = styled.p`
  color: #ff5714;
`
declare const window: any
// window.lazySizesConfig = window.lazySizesConfig || {}
Object.assign(window.lazySizes.cfg, {
  loadHidden: false,
  hFac: 0.5,
  expFactor: 1.5,
  loadMode: 0,
  ricTimeout: 150,
  lazyClass: 'Image--lazyLoad',
  loadedClass: 'Image--lazyLoaded',
  loadingClass: 'lazy-loading',
  customMedia: {
    '--small': '(max-width: 480px)',
    '--medium': '(max-width: 767px)',
    '--mediumup': '(min-width: 768px)',
    '--large': '(max-width: 1024px)',
    '--xlarge': '(min-width: 1280px)',
  },
})

const Main: React.FC = () => {
  // const contentData = useSelector((state: RootState) => state.main.contentData)
  const content = useSelector((state: RootState) => state.main.contentData.content)
  const title = useSelector((state: RootState) => state.main.contentData.title)
  const miscData = useSelector((state: RootState) => state.main.contentData.miscData)
  const translation = useSelector((state: RootState) => state.main.contentData.translation)
  const langCode = useSelector((state: RootState) => state.main.contentData.langCode)
  const loading = useSelector((state: RootState) => state.main.loading)
  const error = useSelector((state: RootState) => state.main.error)
  const dispatch = useDispatch()
  const {introduction} = content

  useEffect(() => {
    // @ts-ignore
    dispatch(fetchInitial())
  }, [])

  useEffect(() => {
    if (loading) document.body.classList.add('OurStory__LoadingDone')
  }, [loading])

  return (
    <Container>
      {error && <ErrorMessage>{error}</ErrorMessage>}

      {loading ? (
        <Loading />
      ) : (
        <>
          {/*<Loading />*/}
          <TopSection introduction={introduction} translation={translation} langCode={langCode} title={title} />
          <SecondSection miscData={miscData} langCode={langCode} />
          <Independent miscData={miscData} langCode={langCode} />
          <GlobalPhenomenon miscData={miscData} translation={translation} langCode={langCode} />
          <BottomSection translation={translation} langCode={langCode} />
        </>
      )}
    </Container>
  )
}

export default Main
